import { useController, Control } from 'react-hook-form';

import { LiftSuspensionFormValues } from './types';
import {
  createMaxLengthValidator,
  isRequired,
  isValidInput,
} from '../../validators';

export const useControllers = (
  control: Control<LiftSuspensionFormValues, any, LiftSuspensionFormValues>
) => {
  const {
    field: {
      value: explanation,
      onChange: setExplanation,
      onBlur: validateExplanation,
    },
    fieldState: { error: explanationError },
  } = useController({
    control,
    name: 'explanation',
    rules: {
      validate: {
        isRequired,
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(3000),
      },
    },
  });

  return {
    explanation,
    setExplanation,
    validateExplanation,
    explanationError,
  };
};
